export default {
  translation: {
    "app": {
      "title": "Matrix Chat"
    },
    "login": {
      "title": "Login",
      "username": "Username",
      "password": "Password",
      "loginButton": "Login",
      "usernameRequired": "Please enter your username",
      "passwordRequired": "Please enter your password",
      "invalidCredentials": "Invalid username or password",
      "loginError": "Login error: {{error}}",
      "loginFailed": "Failed to log in. Please try again."
    },
    "header": {
      "logout": "Logout",
      "userManagement": "User Management",
      "reconnect": "Reconnect"
    },
    "chat": {
      "selectRoom": "Select a room to start chatting",
      "loading": "Loading rooms...",
      "connectionLost": "Connection lost",
      "reconnecting": "Reconnecting...",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "reconnectButton": "Reconnect",
      "onlineMembersCount": "{{count}} online",
      "typing": "{{user}} is typing...",
      "reply": "Reply",
      "edit": "Edit",
      "delete": "Delete",
      "cancel": "Cancel",
      "save": "Save",
      "messageInput": "Type a message...",
      "uploadFile": "Upload file",
      "sendMessage": "Send message",
      "editMessage": "Edit message",
      "replyTo": "Type your reply...",
      "editingMessage": "Editing message",
      "edited": "Edited",
      "earlier": "earlier",
      "addReaction": "Add reaction",
      "messageActions": "Message actions",
      "deleteMessage": "Delete message",
      "deleteMessageConfirm": "Are you sure you want to delete this message? This action cannot be undone.",
      "deletedMessage": "This message was deleted"
    },
    "notifications": {
      "newMessage": "New message",
      "connectionProblem": "Connection problems. Retrying in {{seconds}} sec.",
      "serverUnavailable": "Server unavailable. Please try again later.",
      "alreadyConnecting": "Already connecting, please wait",
      "tooFrequentAttempts": "Wait, too frequent attempts ({{seconds}}s)",
      "sessionExpired": "Your session has expired. Please log in again."
    },
    "members": {
      "online": "Online",
      "offline": "Offline",
      "unavailable": "Unavailable",
      "unknown": "Unknown",
      "members": "Members",
      "justNow": "just now",
      "minutes": "min ago",
      "hours": "h ago",
      "days": "d ago",
      "connections": "connections",
      "moderator": "Moderator",
      "lastActivity": "Last activity",
      "support": "Support",
      "loadingRoomMembers": "Loading room members {{roomId}}...",
      "selectRoomForMembers": "Select room for members",
      "myTeam": "My team",
      "noMembers": "No members",
      "updated": "Updated",
      "updatedAuto": "auto"
    },
    "language": {
      "english": "English",
      "russian": "Русский",
      "ukrainian": "Українська"
    },
    "fileAttachment": {
      "attachments": "Attachments",
      "unknown": "Unknown file",
      "unknownSize": "Unknown size",
      "download": "Download",
      "view": "View",
      "dropFileHere": "Drop file here",
      "uploadFiles": "Upload files",
      "clickOrDragFiles": "Click or drag files to this area to upload"
    },
    "emojiPicker": {
      "title": "Select emoji",
      "description": "Select emoji for sending",
      "search": "Search",
      "addReaction": "Click to add",
      "removeReaction": "Click to remove"
    },
    "messageList": {
      "loading": "Loading messages...",
      "loadMore": "Load previous messages",
      "loadMoreDeep": "Load more older messages",
      "reachedStartOfHistory": "Reached start of history"
    },
    "notificationSettings": {
      "title": "Notification settings",
      "soundNotifications": "Sound notifications",
      "close": "Close",
      "enableSound": "Enable sound",
      "disableSound": "Disable sound",
      "listen": "Listen",
      "soundSelection": "Sound selection"
    },
    "roomsList": {
      "noMessages": "No messages",
      "emptyMessage": "Empty message",
      "chatRooms": "Rooms"
    },
    "serviceMessage": {
      "join": "now with us",
      "leave": "left",
      "restricted": "only for"
    },
    "userManagement": {
      "noWebSocketConnection": "No WebSocket connection",
      "userAdded": "User {{username}} added successfully",
      "userUpdated": "User {{username}} updated successfully",
      "userDeleted": "User {{username}} deleted successfully",
      "confirmDeletion": "Confirm deletion",
      "confirmDeletionContent": "Are you sure you want to delete user \"{{username}}\"?",
      "username": "Username",
      "created": "Created",
      "actions": "Actions",
      "noPermission": "You don't have permission to manage users",
      "userManagement": "User Management",
      "addUser": "Add User",
      "addNewUser": "Add New User",
      "usernameRequired": "Please input username!",
      "password": "Password",
      "passwordRequired": "Please input password!",
      "cancel": "Cancel",
      "changePassword": "Change Password for {{username}}",
      "newPassword": "New Password",
      "updatePassword": "Update Password",
      "newPasswordRequired": "Please input new password!",
      "userNotSelected": "User not selected",
      "deletingUser": "Deleting user...",
      "editPassword": "Change Password for {{username}}",
      "deleteUser": "Delete User {{username}}",
      "searchUsername": "Search by username",
      "updateList": "Update List",
      "noData": "No data",
      "delete": "Delete",
      "attention": "Attention",
      "ifUserIsAuthorized": "If the user is currently authorized, their session will be forcibly terminated."
    },
    "search": {
      "title": "Search Messages",
      "placeholder": "Search in this room...",
      "button": "Search",
      "searching": "Searching...",
      "resultsFound": "Found {{count}} result(s)",
      "noResults": "No results found",
      "tryDifferent": "Try a different search query",
      "startSearching": "Enter a search query to find messages",
      "newestFirst": "Newest first",
      "oldestFirst": "Oldest first",
      "sortNewestFirst": "Sort: newest first",
      "sortOldestFirst": "Sort: oldest first",
      "tip": "Tip: Search is case-insensitive",
      "total": "Total"
    },
    "common": {
      "more": "more"
    },
    "message": {
      "edited": "edited"
    }
  }
};
